export default {
  users: 'Users',
  'users.domain.name': 'Name',

  'users.create': 'Create New User',
};
